import { useState, useEffect } from 'react';
import { sample } from 'lodash';

const DEFAULT_IMAGE_URLS = [
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-1.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-2.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-3.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-4.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-5.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-6.png',
  'https://cdn-assets.alltrails.com/fallback_gradients/grad-7.png'
];

const sampleRandomImage = () => {
  return sample(DEFAULT_IMAGE_URLS);
};

const useImage = (img = null, getFallback = sampleRandomImage) => {
  const [imageUrl, updateImageUrl] = useState(img || getFallback());

  useEffect(() => {
    if (!imageUrl) {
      updateImageUrl(getFallback());
    }
  }, [imageUrl]);

  return [imageUrl, updateImageUrl];
};

export default useImage;
